(() => {
 const states = new WeakMap();
 function state(button) {
  const card = button.closest('product-card, .fr-edit-card, .loving-look-card');
  if (!card) return null;
  if (states.has(card)) return states.get(card);
  const image = card.querySelector('.loving-look-card__image img, .fr-edit-image-link img, slideshow-slide[aria-hidden="false"] img, slideshow-slide img, .card-gallery img');
  if (!image) return null;
  const host = image.parentElement;
  host.classList.add('fr-preview-host');
  const overlay = document.createElement('img'); overlay.className = 'fr-preview-overlay'; overlay.alt = ''; overlay.hidden = true; host.append(overlay);
  const links = [...card.querySelectorAll('a[href]')];
  const s = {card, overlay, selected:null, links, urls:links.map(a=>a.getAttribute('href'))}; states.set(card,s); return s;
 }
 function preview(button) {
  const s=state(button); if (!s) return;
  if (button.dataset.previewSrc) {s.overlay.src=button.dataset.previewSrc;s.overlay.hidden=false;} else s.overlay.hidden=true;
 }
 function restore(button) {const s=state(button);if(!s)return;if(s.selected)preview(s.selected);else s.overlay.hidden=true;}
 document.addEventListener('pointerover', e => {const b=e.target.closest('.fr-color-preview');if(b)preview(b);});
 document.addEventListener('pointerout', e => {const b=e.target.closest('.fr-color-preview');if(b&&!b.contains(e.relatedTarget))restore(b);});
 document.addEventListener('focusin', e => {const b=e.target.closest('.fr-color-preview');if(b)preview(b);});
 document.addEventListener('focusout', e => {const b=e.target.closest('.fr-color-preview');if(b)restore(b);});
 document.addEventListener('click', e => {const b=e.target.closest('.fr-color-preview');if(!b)return;e.preventDefault();e.stopPropagation();const s=state(b);if(!s)return;s.selected=b;preview(b);s.card.querySelectorAll('.fr-color-preview').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));if(b.dataset.variantUrl)s.links.forEach(a=>a.setAttribute('href',b.dataset.variantUrl));},true);
})();
